// extracted by mini-css-extract-plugin
export default {"productDescription":"Q_-z","featuredDescription":"R_-z","description":"S_-z","more":"T_-z","descriptionSku":"U_-z"};